import React from 'react';
import PageFade from '@/common/components/PageFade.tsx';
import PatientReferralPage from './Page.tsx';
import { ActionFunctionArgs } from 'react-router-dom';
import { submitPatientReferral } from '@/common/api/PatientReferrals.ts';
import { ApiError } from '@/common/types/errors';
import { PatientReferralData } from '@/common/types';

export const action = async ({ request }: ActionFunctionArgs) => {
  const formData = await request.formData();
  const { recaptcha_token, ...referralData } = Object.fromEntries(
    formData.entries()
  );

  const data = {
    recaptchaToken: recaptcha_token?.toString() || '',
    patient_referral: referralData as PatientReferralData,
  };

  try {
    await submitPatientReferral(data);
    return { success: true };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      if (error.status === 403) {
        return {
          success: false,
          error: `CAPTCHA verification failed`,
        };
      }
    }
    return {
      success: false,
      error: 'Something went wrong. Please try again later.',
    };
  }
};

const PatientReferralRoute: React.FC = () => {
  return (
    <PageFade>
      <PatientReferralPage />
    </PageFade>
  );
};

export default PatientReferralRoute;
